export class TextConstants {
  static readonly empty = '- empty -';
  static readonly notAvailable = 'N/A';
  static readonly nbsp = '\u00A0';
  static readonly noReportedQueueOrProcess = 'No queue or process has been selected to be reported to the business';
  static readonly manualProcessingInfoMissing = 'Enter the cost and time of manual processing in the Organization settings to find out.';

  static comparedToPrevDayString(previousDate: string): string {
    return `Compared to the previous day (${previousDate})`;
  }
}
